import React from 'react'
import styles from './Numbers.module.scss'
import cl from 'classnames'
import { NumbersProps } from './Numbers.types'

const NumbersComponent = (props: NumbersProps) => {
  const {
    overflowEllipsis,
    horizontalFillLine,
    className,
    children,
    ...rest
  } = props

  return (
    <p
      className={cl(styles.numbers, {
        [styles.textOverflow]: overflowEllipsis
      }, className)}
      {...rest}
    >
      {children}
      {horizontalFillLine && <span className={styles.horizontalLine} />}
    </p>
  )
}

const Numbers = NumbersComponent
export { Numbers }
